import { types } from 'mobx-state-tree';

import { shipmentStatusTranslation } from './ShipmentStore';

export default types
  .model('ShipmentSummary', {
    id: types.number,
    updated_at: types.string,
    order_item: types.string,
    shipper: types.string,
    rate: types.number,
    from_location: types.string,
    to_location: types.string,
    status: types.string,
    direction: types.string,
  })
  .views(self => ({
    get human_status() {
      return shipmentStatusTranslation[self.status] || `Unknown status (${self.status})`;
    },
    get human_direction() {
      return { deliver: 'Delivery', return: 'Return' }[self.direction];
    },
  }));
